import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Box, IconButton } from '@frontierag/frontier-ui-library';
import { Close as CloseIcon } from '@frontierag/frontier-ui-library/icons';
import { ONLINE_NOTIFICATION_DURATION } from 'appConstants';
import { useOfflineData } from 'contexts/OfflineData';

export default function OfflineNotification() {
  const { t } = useTranslation();
  const {
    state: { isOffline },
  } = useOfflineData();
  const [showNotification, setShowNotification] = useState<boolean>();

  useEffect(() => {
    if (isOffline && !showNotification) {
      setShowNotification(true);
    }
  }, [isOffline, showNotification, setShowNotification]);

  useEffect(() => {
    if (!isOffline && showNotification) {
      setShowNotification(true);

      const timeId = setTimeout(() => {
        setShowNotification(false);
      }, ONLINE_NOTIFICATION_DURATION);

      return () => {
        clearTimeout(timeId);
      };
    }
  }, [isOffline, showNotification, setShowNotification]);

  const onClose = () => setShowNotification(false);

  if (!showNotification) return null;

  return (
    <Box py={2} px={3}>
      {isOffline ? (
        <Alert severity="warning">{t('OfflineNotification:youAreOffline')}</Alert>
      ) : (
        <Alert
          severity="success"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={onClose}
              title={t('tooltips.close')}
            >
              <CloseIcon />
            </IconButton>
          }
        >
          {t('OfflineNotification:youAreOnline')}
        </Alert>
      )}
    </Box>
  );
}
